/* eslint-disable */
import { lazy } from 'react';

export const UserTradingAccountsLayoutAsync = lazy(
  () => import('@components-member/TradingAccounts/TradingAccountsLayout'),
);
export const TicketAsync = lazy(() =>
  import('components/user/Tickets').then((module) => ({
    default: module.TicketRouters,
  })),
);
export const NotificationAsync = lazy(() =>
  import('components/user/notifications').then((module) => ({
    default: module.NotificationsWithErrorBoundary,
  })),
);
export const TradingContestRouterAsync = lazy(
  () => import('@components-member/Pages/TradingContest/TradingContest.router'),
);
export const LoyaltyProgramRouterAsync = lazy(() =>
  import('@components-member/Pages/LoyaltyProgram/LoyaltyProgram.router').then((module) => ({
    default: module.LoyaltyProgramRouter,
  })),
);
export const SettingsAsync = lazy(() => import('components/user/settings'));
export const ProfileAsync = lazy(() => import('components/user/profile'));
export const PspAsync = lazy(() => import('components/user/psp'));
export const PartnershipAsync = lazy(() => import('components/user/partnership'));
export const SalesAsync = lazy(() => import('components/user/Sales'));
export const UserDetailsAsync = lazy(() =>
  import('components/user/Sales/UserClients').then((module) => ({
    default: module.UserClientDetails,
  })),
);
export const UserFAQAsync = lazy(() => import(/* webpackChunkName: "faq" */ 'components/user/faq'));
export const LegalDocumentsAsync = lazy(() =>
  import('components/user/LegalDocuments').then((module) => ({
    default: module.LegalDocuments,
  })),
);
export const BonusesAsync = lazy(() => import('components/user/Bonuses'));
export const MamCreateLPOAViaLinkAsync = lazy(() => import('components/user/mam/createLPOAViaLink'));
export const LegalTradingPlatformAsync = lazy(() =>
  import('components/user/LegalTradings/LegalTradingPlatforms').then((module) => ({
    default: module.LegalTradingPlatforms,
  })),
);
export const LegalTradingToolsAsync = lazy(() =>
  import('components/user/LegalTradings/LegalTradingTools').then((module) => ({
    default: module.LegalTradingTools,
  })),
);
/* Social Trading */
export const MastersRatingAsync = lazy(() =>
  import('components/user/socialTrading/MastersRating').then((module) => ({
    default: module.MastersRating,
  })),
);
export const MyStatisticsAsync = lazy(() =>
  import('components/user/socialTrading/MyStatistics').then((module) => ({
    default: module.MyStatistics,
  })),
);
export const InvestorRouterAsync = lazy(() =>
  import('components/user/socialTrading/MyStatistics/details/investors/InvestorRouter').then((module) => ({
    default: module.InvestorRouter,
  })),
);
export const MastersDetailsAsync = lazy(() =>
  import('components/user/socialTrading/MyStatistics/details/masters/mastersDetails').then((module) => ({
    default: module.MastersDetails,
  })),
);
export const OperationHistoryAsync = lazy(() =>
  import('components/user/socialTrading/OperationHistory').then((module) => ({ default: module.OperationHistory })),
);
export const MasterProfileAsync = lazy(() =>
  import('components/user/socialTrading/MasterProfile').then((module) => ({
    default: module.MasterProfile,
  })),
);
export const ReferralLinkDetailsAsync = lazy(() =>
  import('components/user/partnership/IB/referralLinks/referralLinkDetails').then((module) => ({
    default: module.ReferralLinkDetails,
  })),
);
